/**
 * @file hero-banner.js
 */
(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.kodakHeroBanner = {
    attach: function (context, settings) {
      const colors = [
        "orange",
        "deepPurple",
        "darkTeal",
        "lightTeal",
        "kodakTradeDressRed",
      ];
      if ($(".paragraph--type--hero h1").length > 0) {
        $(".paragraph--type--hero h1").attr('class', '');
        $(".paragraph--type--hero h1").addClass(
          colors[Math.floor(Math.random() * colors.length)]
        );
      }
    },
  };
})(jQuery, Drupal, once);
